import * as React from 'react';

import { SVGProps } from './type';

const CheckboxIndeterminate = (props: SVGProps) => {
  const { width = 14, height = 2, color = '#FFF' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.167 1h11.666"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckboxIndeterminate;
